import { api } from '@/lib/axios';
import type { ApiResponse } from '@/types/api';

export interface NotificationRow {
  id: string;
  type: string;
  title: string;
  body: string | null;
  resource_ref: Record<string, unknown> | null;
  is_read: boolean;
  created_at: string;
}

export async function fetchNotifications(limit = 20): Promise<NotificationRow[]> {
  const res = await api.get<ApiResponse<NotificationRow[]>>('/notifications', {
    params: { limit },
  });
  return res.data.data;
}

export async function fetchUnreadCount(): Promise<number> {
  const res = await api.get<ApiResponse<{ unread: number }>>('/notifications/unread-count');
  return res.data.data.unread;
}

export async function markRead(id: string): Promise<void> {
  await api.patch(`/notifications/${id}/read`);
}

export async function markAllRead(): Promise<void> {
  await api.post('/notifications/read-all');
}
